import React from "react";
import { useFetchData, useParseRouteActions } from "../../../helpers/GlobalHelper";
import LmsFormGenerator, { BCFormController } from "../ui/LmsFormGenerator";
import LmsTable from "../ui/LmsTable";

const FundsBankLocHistoryTable = () => (
  <LmsTable
    actionButtons={["export"]}
    apiSuffix="funds/bank-loc-history"
    sortable={["Created On"]}
    columnLabelsDictionary={{
      locestablishedDate: "LOC Established Date",
      locamount: "LOC Amount",
      locrate: "LOC Rate",
      locrateEffectiveDate: "LOC Rate Effective Date",
      bankLocversion: "Bank LOC Version",
      bankOrganization: "Bank",
      fundOrganization: "Fund",
    }}
    dataRules={[
      { field: "locamount", rule: "format", display: "dollar" },
      { field: "loanFee", rule: "format", display: "dollar" },
      { field: "cashOnHand", rule: "format", display: "dollar" },
    ]}
    columnClickOptions={{ fundOrganization: { path: "/bank-loc-history/{id}", idProp: "id" } }}
  />
);

const DetailedFundsBankLocHistory = ({ id }) => {
  const [{ data = {}, isLoading, error }] = useFetchData(`/funds/bank-loc-history/${id}`);
  const myForm = new BCFormController(data, { initIsDisabled: true });
  [
    [
      myForm.getDropdownDisplayField("Fund", { required: true, name: "fundOrganizationDisplay" }),
      myForm.getDropdownDisplayField("Bank", { required: true, name: "bankOrganizationDisplay" }),
      myForm.getDisplayField("Advance Percentage", { required: true }),
      myForm.getCurrencyField("Loan Fee", { required: true }),
    ],
    [
      myForm.getCurrencyField("LOC Amount", { required: true, name: "locamount" }),
      myForm.getCalendarField("Effective Date"),
      myForm.getCalendarField("Expiry Date"),
      myForm.getCalendarField("LOC Established Date", { name: "locestablishedDate" }),
    ],
    [
      myForm.getDisplayField("LOC Rate", { name: "locrate" }),
      myForm.getCalendarField("LOC Rate Effective Date", { name: "locrateEffectiveDate" }),
      myForm.getCheckboxField("Is Active"),
    ],
  ].forEach((fields) => myForm.addGroupFields(fields));

  return (
    <LmsFormGenerator myForm={myForm} isLoading={isLoading} error={error} actions={["close"]} />
  );
};

const LmsFundsBankLocHistory = ({ params = {}, history }) => {
  const { isMainPage, isEdit, isActionAllowed, id } = useParseRouteActions(params);

  if (!isActionAllowed) {
    history.goBack();
  }

  return (
    <>
      {isMainPage && <FundsBankLocHistoryTable />}
      {isEdit && <DetailedFundsBankLocHistory id={id} />}
    </>
  );
};

export default LmsFundsBankLocHistory;
